import { twMerge, type ClassNameValue } from "tailwind-merge";

/** Join class names; later Tailwind utilities win over conflicting earlier ones. */
export const cn = (...classes: ClassNameValue[]): string => twMerge(classes);
